"use client";

import { Card } from "react-bootstrap";

const MaterialSymbolsIcons = () => {
  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4 text-center">
          <pre
            className="code-block"
            style={{
              backgroundColor: "#f5f2f0",
              padding: "15px 20px",
              marginBottom: 0,
              borderRadius: "4px",
              overflowX: "auto",
              fontSize: "14px",
              lineHeight: 1.5,
            }}
          >
            <code
              className="language-markup"
              style={{
                backgroundColor: "transparent",
                padding: "0",
                color: "#333",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
              }}
            >
              &lt;span
              class=&quot;material-symbols-outlined&quot;&gt;search&lt;/span&gt;
            </code>
          </pre>
        </Card.Body>
      </Card>

      <div className="row">
        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">search</span>
              <span className="d-block mt-4">search</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">home</span>
              <span className="d-block mt-4">home</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">menu</span>
              <span className="d-block mt-4">menu</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">close</span>
              <span className="d-block mt-4">close</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">settings</span>
              <span className="d-block mt-4">settings</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">done</span>
              <span className="d-block mt-4">done</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                expand_more
              </span>
              <span className="d-block mt-4">expand_more</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">search</span>
              <span className="d-block mt-4">search</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                check_circle
              </span>
              <span className="d-block mt-4">check_circle</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">favorite</span>
              <span className="d-block mt-4">favorite</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">add</span>
              <span className="d-block mt-4">add</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                arrow_back
              </span>
              <span className="d-block mt-4">arrow_back</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">star</span>
              <span className="d-block mt-4">star</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                chevron_right
              </span>
              <span className="d-block mt-4">chevron_right</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">logout</span>
              <span className="d-block mt-4">logout</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                arrow_forward_ios
              </span>
              <span className="d-block mt-4">arrow_forward_ios</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                add_circle
              </span>
              <span className="d-block mt-4">add_circle</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">cancel</span>
              <span className="d-block mt-4">cancel</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                arrow_back_ios
              </span>
              <span className="d-block mt-4">arrow_back_ios</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                arrow_forward
              </span>
              <span className="d-block mt-4">arrow_forward</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                arrow_drop_down
              </span>
              <span className="d-block mt-4">arrow_drop_down</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">check</span>
              <span className="d-block mt-4">check</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">check_box</span>
              <span className="d-block mt-4">check_box</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">toggle_on</span>
              <span className="d-block mt-4">toggle_on</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                open_in_new
              </span>
              <span className="d-block mt-4">open_in_new</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">grade</span>
              <span className="d-block mt-4">grade</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <div className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">refresh</span>
              <span className="d-block mt-4">refresh</span>
            </div>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                check_box_outline_blank
              </span>
              <span className="d-block mt-4">check_box_outline_blank</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">login</span>
              <span className="d-block mt-4">login</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-2 col-sm-6 col-md-3">
          <Card className="bg-white border-0 rounded-3 mb-4">
            <Card.Body className="p-4 text-center">
              <span className="material-symbols-outlined fs-24">
                chevron_left
              </span>
              <span className="d-block mt-4">chevron_left</span>
            </Card.Body>
          </Card>
        </div>

        <div className="col-lg-12 text-center mb-4">
          <a
            href="https://fonts.google.com/icons"
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary py-2 px-4 text-decoration-none rounded-pill"
          >
            <span className="d-inline-block py-1">View All Icons</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default MaterialSymbolsIcons;
